import Slider from 'react-slick';
import React, { useState } from 'react';
import "slick-carousel/slick/slick.css";
import Heart from '../assets/heart.png';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import crownSVG from '../assets/crown.svg';
import Gallery from '../components/Gallery';
import "slick-carousel/slick/slick-theme.css";
import PrimaryLink from '../components/StyledLinks';
import shareFoodImg from '../assets/share-food.png';
import heroBackground from '../assets/hero-bg-c.png';
import pregnancyImg from '../assets/makoko/makoko1.jpeg';
import valueHeroImgOne from '../assets/v-hero-img1.png';
import ProjectSlider from '../components/ProjectSlider';
import valueHeroImgTwo from '../assets/v-hero-img2.png';
import gallaryImgOne from '../assets/makoko/makoko1.jpeg';
import gallaryImgTwo from '../assets/makoko/makoko2.jpeg';
import gallaryImgFour from '../assets/makoko/makoko4.jpeg';
import gallaryImgFive from '../assets/makoko/makoko5.jpeg';
import gallaryImgThree from '../assets/makoko/makoko3.jpeg';
import backgroundOneImg from '../assets/background-1.svg';
import backgroundTwoImg from '../assets/background-2.svg';
import valueHeroImgThree from '../assets/v-hero-img3.png';
import { SecondaryLink } from '../components/StyledLinks';
import { DonateModal } from '../components/DonateModal';
import backgroundThreeImg from '../assets/background-3.png';
import motherChildImg from '../assets/mother-child-hug.png';
import smilingStudentImg from '../assets/makoko/makoko2.jpeg';


const HomeView = () => {
  const [isDonateModalOpen, setModelState] = useState(false)
  const images = [
    { id: 1, src: gallaryImgFive },
    { id: 4, src: gallaryImgThree },
    { id: 2, src: gallaryImgTwo },
    { id: 6, src: gallaryImgFour },
  ];

  const settings = {
    dots: true,
    speed: 2000,
    arrows: false,
    infinite: true,
    cssEase: "linear",
    slidesToScroll: 1,
    autoplaySpeed: 2000,
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  return (
    <>
      <main>
        <DonateModal isOpen={isDonateModalOpen} onClose={() => setModelState(!isDonateModalOpen)} />
        <header className='md:h-screen w-lvw bg-center bg-no-repeat bg-cover flex flex-col justify-between' style={{ backgroundImage: `url(${heroBackground})` }}>
          <Navbar />

          <section className='md:max-h-fit flex w-full grow flex-col gap-y-14 p-2 justify-center md:place-items-center self-end'>
            <div className='md:w-10/12 mx-auto'>
              <div className='relative'>
                <svg className='absolute -top-6 md:-top-12 xl:-top-8 -left-4 sm:left-[30px] lg:left-16 xl:left-24 w-[310px] h-[110px] sm:w-[130px] sm:h-[130px] md:w-[150px] md:h-[150px] xl:w-[279px] xl:h-[146px]' viewBox="0 0 279 146" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M268.115 39.9999C269.426 45.0322 267.337 50.8496 262.088 57.1427C256.853 63.4183 248.584 70.0284 237.873 76.5744C216.46 89.6613 185.439 102.401 149.889 111.668C114.339 120.935 81.0466 124.96 55.9697 123.992C43.4262 123.507 32.9825 121.775 25.3502 118.854C17.6967 115.924 13.0335 111.867 11.7218 106.834C10.41 101.802 12.4991 95.9847 17.7485 89.6916C22.9834 83.416 31.2525 76.806 41.9633 70.2599C63.3765 57.173 94.3971 44.4334 129.947 35.1664C165.497 25.8995 198.79 21.8745 223.867 22.8428C236.41 23.3271 246.854 25.0592 254.486 27.9807C262.14 30.9104 266.803 34.9677 268.115 39.9999Z" stroke="#FEBE58" strokeWidth="1.5" />
                  <path d="M273.961 78.6133C273.8 83.8112 270.156 88.8034 263.344 93.3605C256.552 97.905 246.755 101.915 234.632 105.174C210.398 111.691 177.043 115.165 140.323 114.03C103.602 112.894 70.5261 107.367 46.7401 99.3656C34.8424 95.3634 25.3112 90.7562 18.8126 85.8008C12.296 80.8316 8.96638 75.6239 9.12708 70.4259C9.28777 65.228 12.9327 60.2359 19.7439 55.6787C26.5361 51.1342 36.3338 47.1245 48.4559 43.8649C72.6907 37.3483 106.045 33.8744 142.766 35.0096C179.486 36.1448 212.562 41.6724 236.348 49.6736C248.246 53.6758 257.777 58.2831 264.276 63.2385C270.792 68.2077 274.122 73.4154 273.961 78.6133Z" stroke="#FEBE58" strokeWidth="1.5" />
                </svg>
              </div>
              <h1 className='text-white text-6xl sm:text-4xl lg:text-6xl font-extrabold md:text-center leading-tight tf-rozha'>Abiyamo is Yoruba word meaning Motherhood</h1>
              <p className='md:w-8/12 mx-auto mt-6 md:mt-3 text-2xl md:text-xl font-thin tf-bellefair md:text-center tracking-widest text-white'>Abiyamo is a non-profit organization that is committed to improving the lives of children and mothers in our community. We understand the unique challenges faced by parents</p>
            </div>

            <div className='max-w-56 md:max-w-fit'>
              {/* <PrimaryLink to={'https://youtube.com/shorts/X4V37PhMFys?si=HlWz5G4-eCE-0rKL'}>
                <span className="flex flex-row place-items-center gap-x-1">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.25 3.5C7.425 3.5 3.5 7.425 3.5 12.25C3.5 17.075 7.425 21 12.25 21C17.075 21 21 17.075 21 12.25C21 7.425 17.075 3.5 12.25 3.5ZM12.25 22.5C6.598 22.5 2 17.902 2 12.25C2 6.598 6.598 2 12.25 2C17.902 2 22.5 6.598 22.5 12.25C22.5 17.902 17.902 22.5 12.25 22.5Z" fill="#ffffff" />
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M11.134 10.0865C10.957 11.0875 10.954 13.4785 11.131 14.4285C12.009 14.1185 13.911 12.8685 14.423 12.2495C13.913 11.6485 12.035 10.4245 11.134 10.0865ZM10.828 16.0015C10.558 16.0015 10.302 15.9245 10.093 15.7165C9.932 15.5575 9.502 15.1325 9.5 12.3335C9.499 9.36151 9.946 8.91951 10.093 8.77251C10.616 8.25451 11.468 8.60951 11.831 8.76151C12.351 8.97851 16 10.8475 16 12.2455C16 13.5555 12.716 15.3875 11.877 15.7375C11.55 15.8735 11.177 16.0015 10.828 16.0015Z" fill="#ffffff" />
                  </svg>

                  <div className="flex flex-col -gap-y-1">
                    <span className="text-white text-xl tf-rozha">Watch Video</span>
                    <span className="border border-white"></span>
                  </div>
                </span>
              </PrimaryLink> */}
            </div>

            <div className='hidden md:block'>
              <svg width="28" height="158" viewBox="0 0 28 158" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.6843 0.999999L14.6843 0.249999L13.1843 0.249999L13.1843 0.999999L14.6843 0.999999ZM13.9343 156.865L14.6843 156.865L13.9343 156.865ZM13.1843 157.026C13.1843 157.44 13.5201 157.776 13.9343 157.776C14.3486 157.776 14.6843 157.44 14.6843 157.026L13.1843 157.026ZM27 141.773L27.75 141.773L27.75 140.273L27 140.273L27 141.773ZM13.3805 156.56C13.212 156.938 13.3822 157.382 13.7605 157.55C14.1389 157.719 14.5823 157.549 14.7508 157.17L13.3805 156.56ZM0.999999 140.273L0.249999 140.273L0.249999 141.773L0.999999 141.773L0.999999 140.273ZM13.1843 0.999999L13.1843 156.865L14.6843 156.865L14.6843 0.999999L13.1843 0.999999ZM13.1843 156.865L13.1843 157.026L14.6843 157.026L14.6843 156.865L13.1843 156.865ZM27 140.273C25.2145 140.273 23.4843 141.455 21.9688 142.968C20.4234 144.51 18.9558 146.543 17.6937 148.544C16.4279 150.55 15.3508 152.552 14.5909 154.051C14.2107 154.8 13.909 155.426 13.702 155.864C13.5985 156.084 13.5186 156.256 13.4644 156.375C13.4372 156.434 13.4165 156.48 13.4025 156.511C13.3954 156.527 13.3901 156.539 13.3864 156.547C13.3846 156.551 13.3832 156.554 13.3822 156.556C13.3817 156.557 13.3813 156.558 13.381 156.559C13.3809 156.559 13.3808 156.559 13.3807 156.56C13.3806 156.56 13.3805 156.56 14.0657 156.865C14.7508 157.17 14.7508 157.17 14.7508 157.17C14.7508 157.17 14.7508 157.17 14.7509 157.17C14.7511 157.169 14.7513 157.169 14.7517 157.168C14.7524 157.166 14.7536 157.164 14.7552 157.16C14.7583 157.153 14.7632 157.143 14.7697 157.128C14.7827 157.099 14.8023 157.056 14.8283 156.999C14.8803 156.886 14.9577 156.718 15.0586 156.504C15.2603 156.077 15.5558 155.464 15.9287 154.729C16.6754 153.257 17.7294 151.298 18.9623 149.344C20.1988 147.384 21.5973 145.458 23.0284 144.029C24.4892 142.571 25.8458 141.773 27 141.773L27 140.273ZM13.9343 156.865C14.6466 156.63 14.6465 156.63 14.6464 156.629C14.6464 156.629 14.6463 156.629 14.6461 156.629C14.6459 156.628 14.6456 156.627 14.6452 156.626C14.6444 156.623 14.6434 156.62 14.6419 156.616C14.6391 156.608 14.635 156.595 14.6297 156.579C14.619 156.548 14.6032 156.502 14.5825 156.442C14.5411 156.322 14.4798 156.148 14.3993 155.927C14.2384 155.486 14.0005 154.858 13.691 154.105C13.0727 152.6 12.1647 150.588 11.0084 148.571C9.8554 146.559 8.43678 144.509 6.78756 142.953C5.14232 141.4 3.19484 140.273 0.999999 140.273L0.999999 141.773C2.6592 141.773 4.25553 142.626 5.7581 144.044C7.25672 145.458 8.58992 147.368 9.70701 149.317C10.8208 151.26 11.701 153.209 12.3036 154.675C12.6045 155.407 12.8351 156.016 12.9901 156.441C13.0676 156.654 13.1261 156.82 13.165 156.932C13.1845 156.989 13.199 157.031 13.2085 157.059C13.2133 157.074 13.2168 157.084 13.2191 157.091C13.2202 157.094 13.221 157.097 13.2215 157.098C13.2218 157.099 13.222 157.1 13.2221 157.1C13.2221 157.1 13.2221 157.1 13.2221 157.1C13.2221 157.1 13.2221 157.1 13.9343 156.865Z" fill="#FEBE58" />
              </svg>
            </div>
          </section>
        </header>

        <section className='flex flex-col md:flex-row min-h-[620px]'>
          <div style={{ backgroundImage: `url(${valueHeroImgOne})` }} className='w-full md:w-4/12 h-auto  bg-center bg-no-repeat bg-cover cursor-pointer group' >
            <div className='relative md:invisible group-hover:visible h-full bg-gradient-to-b from-[#000000B2] to-[#000000e0]'>
              <div className='flex h-full'>
                <article className='w-11/12 mx-auto self-end pb-6 sm:pb-14 flex flex-col gap-y-4 pt-52 sm:pt-24'>
                  <h3 className='text-white text-xl font-extrabold uppercase leading-loose'>The Breast</h3>
                  <p className='text-[#d4d4d4] tf-inter text-md'>This Involves The Child And Mother</p>

                  <ol className='flex flex-col gap-y-2 sm:gap-y-8 list-decimal pl-4'>
                    <li className='text-[#e1e1e1] tf-inter text-md'>The Child: Ensuring that the child have the necessary developmental requirements for growth, performance, and fulfillment (physically, spiritually, mentally, e.t.c) e.g Supporting the physically challenged and estranged (counseling, support, with spiritual guidance)</li>
                    <li className='text-[#e1e1e1] tf-inter text-md'>The Mother: There’re lots mothers go through some are the metabolism of mothers for the different stages of motherhood in counseling, assisting and guidance to be a fulfillment e.g Encouragement of parents to go back to school</li>
                  </ol>
                </article>
              </div>
            </div>
          </div>

          <div style={{ backgroundImage: `url(${valueHeroImgTwo})` }} className='w-full md:w-4/12 h-[420px] md:h-auto  bg-center bg-no-repeat bg-cover cursor-pointer group' >
            <div className='relative md:invisible group-hover:visible h-full bg-gradient-to-b from-[#000000B2] to-[#240738B2]'>
              <div className='flex h-full'>
                <article className='w-11/12 mx-auto self-end  pb-14 flex flex-col gap-y-4'>
                  <h3 className='text-white text-xl font-extrabold uppercase'>The Womb</h3>

                  <p className='text-[#e1e1e1] tf-inter text-md leading-loose'>
                    This symbolizes conception, praying for those looking for the fruit of the womb and also assisting women with related womb issues and counseling. Monitoring those who have conceived to deliver. This involves conception to baby hood.
                  </p>
                </article>
              </div>
            </div>
          </div>

          <div style={{ backgroundImage: `url(${valueHeroImgThree})` }} className='w-full md:w-4/12 h-[420px] md:h-auto  bg-center bg-no-repeat bg-cover cursor-pointer group' >
            <div className='relative md:invisible group-hover:visible h-full bg-gradient-to-b from-[#000000B2] to-[#240738B2]'>
              <div className='flex h-full'>
                <article className='w-11/12 mx-auto self-end pb-14 flex flex-col gap-y-4'>
                  <h3 className='text-white text-xl font-extrabold uppercase'>The Pot</h3>

                  <p className='text-[#e1e1e1] tf-inter text-md leading-relaxed'>
                    Every woman holds the potential to nurture and support her home. Through our month-long empowerment program, we trained 20 women in skills like soap-making, fashion, makeup, and local drink production (kunu, zobo, tiger nut). We also provided financial support and equipment, such as grinding machines, to help women start small businesses. For school support, we offer both financial aid and adoption options for those in need.
                  </p>
                </article>
              </div>
            </div>
          </div>
        </section>

        <section className='flex justify-center flex-col bg-[#fbf8eb] px-2 min-h-[470px] lg:min-h-[580px]'>
          <div className='w-full sm:w-11/12 md:w-9/12 xl:w-7/12 mx-auto'>
            <h3 className='text-5xl sm:text-7xl tf-bellefair font-thin text-center leading-release lg:leading-snug tracking-widest'>We are on a mission to help the helpless</h3>
            <div className='relative top-20 xl:-top-16 xl:-right-24'>
              <img src={`${Heart}`} width={200} className='z-10 absolute -top-[15px] right-0' alt="abiyamo gboja mission is to help the helpless" />
            </div>
            <p className='text-center font-light text-lg tracking-widest mt-6 tf-inter'> "As one whom his mother comforts, so I will comfort you." <br />Isaiah 66:13</p>
          </div>
        </section>

        <section>
          <div className='hidden lg:grid grid-cols-1 lg:grid-cols-3 justify-between place-items-center gap-1 m-1'>
            <div style={{ backgroundImage: `url(${pregnancyImg})` }} className='bg-cover bg-no-repeat bg-center w-full max-h-[430px] min-h-[430px] h-auto'></div>
            <div style={{ backgroundImage: `url(${shareFoodImg})` }} className='bg-cover bg-no-repeat bg-center w-full max-h-[430px] min-h-[430px] h-auto'></div>
            <div style={{ backgroundImage: `url(${smilingStudentImg})` }} className='bg-cover bg-no-repeat bg-center w-full max-h-[430px] min-h-[430px] h-auto'></div>
          </div>


          <div className='slider-container lg:hidden'>
            <Slider {...settings}>
              <img src={`${pregnancyImg}`} className='w-full max-w-full max-h-[430px] min-h-[430px] h-auto' />
              <img src={`${shareFoodImg}`} className='w-full max-w-full max-h-[430px] min-h-[430px] h-auto' />
              <img src={`${smilingStudentImg}`} className='w-full max-w-full max-h-[430px] min-h-[430px] h-auto' />
            </Slider>
          </div>
        </section>

        <section className='bg-[#fff7e7]'>
          <div className='h-fit py-6 lg:min-h-[610px] bg-no-repeat bg-center flex flex-col gap-y-4' style={{ backgroundImage: `url(${backgroundOneImg})` }}>
            <div className='mt-32 relative w-full pb-8 lg:w-8/12 mx-auto bg-[#fcefd5] lg:min-h-[530px] xl:min-h-[420px]'>
              <img src={crownSVG} className='w-36 absolute -left-16 -top-24 lg:left-6 lg:-top-20' />
              <div className='flex justify-center place-items-center h-full w-full mt-10 p-4 lg:p-7'>
                <div className='sm:w-9/12 mx-auto flex flex-col gap-y-3'>
                  <h3 className='text-4xl lg:text-4xl tf-rozha text-center tracking-widest leading-snug'>You also can be a part of this</h3>
                  <span className='w-10/12 mx-auto space-y-3'>
                    <p className='text-md sm:text-sm tf-inter font-light tracking-wide leading-snug' style={{ fontWeight: 300, lineHeight: 2 }}>At Abiyamo, we believe that every child deserves the opportunity to thrive, and every parent deserves the support they need to navigate the journey of parenthood. Our comprehensive programs are designed to provide a holistic approach to family well-being, addressing the physical, emotional, and social needs of both children and their caregivers.</p>
                    <p className='text-md sm:text-sm tf-inter font-light tracking-wide leading-snug' style={{ fontWeight: 300, lineHeight: 2 }}>Abiyamo's commitment to supporting families extends far beyond the walls of our organization. Through strategic partnerships, innovative programs.</p>
                  </span>
                </div>
              </div>

              {/* <div className='w-10/12 sm:w-5/12 md:w-4/12 lg:w-3/12 mx-auto z-30'>
                <SecondaryLink to={''} className='z-50'>
                  <span className='text-white underline leading-snug'>Volunteer with us</span>
                </SecondaryLink>
              </div> */}

              <div className='absolute h-full border border-black w-full -left-1 -top-4 sm:-left-4 z-10'>
              </div>
            </div>

            <div className='mt-32 relative w-10/12 p-1 lg:w-8/12 mx-auto bg-[#240738] min-h-[530px] xl:min-h-[420px]'>
              <div className='bg-[length:240%_150%] bg-bottom sm:bg-cover sm:bg-no-repeat sm:bg-center min-h-[430px]' style={{ backgroundImage: `url(${backgroundTwoImg})` }}>
                <div className='relative'>
                  <img src={motherChildImg} alt="" className='relative md:absolute w-[350px] h-[400px] -left-8 -top-12 sm:-left-10 md:top-12 md:-left-16' />
                  <div className='block p-2 md:p-0 md:absolute top-20 left-60'>
                    <div className='flex flex-row place-items-center gap-x-5'>
                      <h4 className=' text-white font-extrabold tf-rozha text-3xl tracking-wider'>Our DNA</h4>
                      <div className='w-40 md:w-64 h-0.5 bg-[#FEBE58]'></div>
                    </div>


                    <div className='w-11/12 sm:w-9/12 mx-auto mt-3'>
                      <p className='text-[#e8e8e8] text-sm sm:text-md tf-inter font-light tracking-wide leading-snug' style={{ fontWeight: 300, lineHeight: 2 }}>At the heart of Abiyamo's mission is a deep commitment to supporting mothers and their children. We understand the unique challenges faced by parents, and our comprehensive programs are designed to provide the tools, resources, and community needed to navigate the joys and complexities.</p>
                      <p className='text-xl font-extrabold text-white mt-3 tf-rozha'>Proverbs 31:25 – Legacy of a Wise Mom "She is clothed with strength and dignity; she can laugh at the days to come”</p>

                      <div className='w-6/12 md:w-4/12 mt-5'>
                        {/* <PrimaryLink to={''}>
                          <span className='font-bold text-sm underline tf-rozha'>Read More</span>
                        </PrimaryLink> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className='bg-[#fff7e7] flex flex-col pb-24'>
          <div className='w-11/12 md:w-9/12 mx-auto pt-24'>
            <h2 className='text-6xl font-bold uppercase tf-rozha'>Upcoming Event</h2>
          </div>

          <div className='h-fit min-h-[810px] w-full bg-no-repeat bg-center sm:bg-right-top bg-cover flex flex-col gap-y-4' style={{ backgroundImage: `url(${backgroundThreeImg})` }}>
            <div className='relative w-full min-h-[810px] bg-[#2b0720b5]'>
              <div className='absolute w-full h-full'>
                <div className='h-full flex gap-y-6 flex-col justify-center place-items-center w-11/12 sm:w-8/12 lg:w-6/12 mx-auto'>
                  <h1 className='text-white text-center text-7xl tf-rozha'>Abiyamo Outreach</h1>
                  <p className='text-white font-light tf-inter text-md leading-loose tracking-wider' style={{ fontWeight: 300 }}>6th of April this year, we fed approximately a million persons, including children, parent. There was music, evangelism, sermon and testimony and also gave gift bags including Biro, Books, Biscuits, sharing of foods, socks, bibles, clothes, Garri. A representative from educational children’s board also came around - A combination of four schools: (to be named). There’s an upcoming outreach at Makoko (November 9th)</p>

                  <PrimaryLink to='#' onClick={() => setModelState(true)}>
                    <span className="flex place-items-center gap-x-1 tf-rozha">
                      <span className="text-black text-md font-extrabold">+</span>
                      <div className="flex flex-col -gap-y-1">
                        <span  className="text-black text-xl">Donate Now</span>
                      </div>
                    </span>
                  </PrimaryLink>
                </div>
              </div>
            </div>
          </div>

          <div className='w-full md:w-9/12 mx-auto flex flex-col gap-y-4 mt-16'>

            <ProjectSlider />
{/* 
            <div className='mt-24 xl:mt-36'></div>
            <div className='w-2/12 h-1 bg-black mx-3 xl:mx-0'></div>

            <div className='w-full lg:w-9/12 px-3 xl:px-0'>
              <h2 className='text-6xl font-bold uppercase tf-rozha tracking-wide'>TESTIMONIES</h2>
              <p className='text-2xl tf-inter tracking-widest leading-loose font-extralight'>Read beautiful stories and experiences with us.</p>
            </div>

            <div className='hidden sm:grid grid-cols-3 mt-12'>
              <div className='min-h-[480px] bg-[#FFE5BA] flex flex-col justify-center'>
                <div className='w-9/12 mx-auto flex flex-col gap-y-9'>
                  <img src={colonImg} className='w-9' />
                  <h3 className='text-lg font-bold tracking-wide leading-loose tf-inter'>Amet eu facilisi posuere ut at cras non ipsum proin nunc purus tellus.</h3>
                  <p className='font-extralight leading-relaxed text-[#0E101199] text-sm'>Amet eu facilisi posuere ut at cras non ipsum proin nunc purus tellus ultricies velit elementum ut dui sed augue ultrices phasellus.</p>
                  <div className='flex flex-row place-items-center gap-x-2'>
                    <img src={testimonialImgOne} className='rounded-full w-12 h-12' />
                    <span className=''>
                      <h3 className='tf-inter font-semibold text-sm'>Victoria Amakiri</h3>
                      <small className='font-extralight italic tf-bellafair'>(Lumina)</small>
                    </span>
                  </div>
                </div>
              </div>

              <div className='min-h-[480px] bg-[#FEBE58] flex flex-col justify-center'>
                <div className='w-9/12 mx-auto flex flex-col gap-y-9'>
                  <img src={colonImg} className='w-9' />
                  <h3 className='text-lg font-bold tracking-wide leading-loose tf-inter'>Amet eu facilisi posuere ut at cras non ipsum proin nunc purus tellus.</h3>
                  <p className='font-extralight leading-relaxed text-[#0E101199] text-sm'>Amet eu facilisi posuere ut at cras non ipsum proin nunc purus tellus ultricies velit elementum ut dui sed augue ultrices phasellus.</p>
                  <div className='flex flex-row place-items-center gap-x-2'>
                    <img src={testimonialImgOne} className='rounded-full w-12 h-12' />
                    <span className=''>
                      <h3 className='tf-inter font-semibold text-sm'>Victoria Amakiri</h3>
                      <small className='font-extralight italic tf-bellafair'>(Lumina)</small>
                    </span>
                  </div>
                </div>
              </div>

              <div className='min-h-[480px] bg-[#FFE5BA] flex flex-col justify-center'>
                <div className='w-9/12 mx-auto flex flex-col gap-y-9'>
                  <img src={colonImg} className='w-9' />
                  <h3 className='text-lg font-bold tracking-wide leading-loose tf-inter'>Amet eu facilisi posuere ut at cras non ipsum proin nunc purus tellus.</h3>
                  <p className='font-extralight leading-relaxed text-[#0E101199] text-sm'>Amet eu facilisi posuere ut at cras non ipsum proin nunc purus tellus ultricies velit elementum ut dui sed augue ultrices phasellus.</p>
                  <div className='flex flex-row place-items-center gap-x-2'>
                    <img src={testimonialImgOne} className='rounded-full w-12 h-12' />
                    <span className=''>
                      <h3 className='tf-inter font-semibold text-sm'>Victoria Amakiri</h3>
                      <small className='font-extralight italic tf-bellafair'>(Lumina)</small>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className='block sm:hidden'>
              <Slider {...settings}>
                <div className='min-h-[480px] bg-[#FFE5BA] flex flex-col justify-center'>
                  <div className='w-9/12 mx-auto flex flex-col gap-y-9'>
                    <img src={colonImg} className='w-9' />
                    <h3 className='text-lg font-bold tracking-wide leading-loose tf-inter'>Amet eu facilisi posuere ut at cras non ipsum proin nunc purus tellus.</h3>
                    <p className='font-extralight leading-relaxed text-[#0E101199] text-sm'>Amet eu facilisi posuere ut at cras non ipsum proin nunc purus tellus ultricies velit elementum ut dui sed augue ultrices phasellus.</p>
                    <div className='flex flex-row place-items-center gap-x-2'>
                      <img src={testimonialImgOne} className='rounded-full w-12 h-12' />
                      <span className=''>
                        <h3 className='tf-inter font-semibold text-sm'>Victoria Amakiri</h3>
                        <small className='font-extralight italic tf-bellafair'>(Lumina)</small>
                      </span>
                    </div>
                  </div>
                </div>

                <div className='min-h-[480px] bg-[#FEBE58] flex flex-col justify-center'>
                  <div className='w-9/12 mx-auto flex flex-col gap-y-9'>
                    <img src={colonImg} className='w-9' />
                    <h3 className='text-lg font-bold tracking-wide leading-loose tf-inter'>Amet eu facilisi posuere ut at cras non ipsum proin nunc purus tellus.</h3>
                    <p className='font-extralight leading-relaxed text-[#0E101199] text-sm'>Amet eu facilisi posuere ut at cras non ipsum proin nunc purus tellus ultricies velit elementum ut dui sed augue ultrices phasellus.</p>
                    <div className='flex flex-row place-items-center gap-x-2'>
                      <img src={testimonialImgOne} className='rounded-full w-12 h-12' />
                      <span className=''>
                        <h3 className='tf-inter font-semibold text-sm'>Victoria Amakiri</h3>
                        <small className='font-extralight italic tf-bellafair'>(Lumina)</small>
                      </span>
                    </div>
                  </div>
                </div>

                <div className='min-h-[480px] bg-[#FFE5BA] flex flex-col justify-center'>
                  <div className='w-9/12 mx-auto flex flex-col gap-y-9'>
                    <img src={colonImg} className='w-9' />
                    <h3 className='text-lg font-bold tracking-wide leading-loose tf-inter'>Amet eu facilisi posuere ut at cras non ipsum proin nunc purus tellus.</h3>
                    <p className='font-extralight leading-relaxed text-[#0E101199] text-sm'>Amet eu facilisi posuere ut at cras non ipsum proin nunc purus tellus ultricies velit elementum ut dui sed augue ultrices phasellus.</p>
                    <div className='flex flex-row place-items-center gap-x-2'>
                      <img src={testimonialImgOne} className='rounded-full w-12 h-12' />
                      <span className=''>
                        <h3 className='tf-inter font-semibold text-sm'>Victoria Amakiri</h3>
                        <small className='font-extralight italic tf-bellafair'>(Lumina)</small>
                      </span>
                    </div>
                  </div>
                </div>
              </Slider>
            </div> */}

            <div className='mt-24 xl:mt-36'></div>
            <div className='w-2/12 h-1 bg-black mx-3 xl:mx-0'></div>

            <div className='w-full lg:w-9/12 px-3 xl:px-0'>
              <h2 className='text-6xl font-bold uppercase tf-rozha tracking-wide'>Gallery</h2>
              <p className='text-2xl tf-inter tracking-widest leading-loose font-extralight'>See beautiful stories and experiences with us.</p>
            </div>

            <div>
              <Gallery images={images} />
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  )
}


export default HomeView
